// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

import { adHocSelfPaySchema } from "./adHocSelfPaySchema.ts";
import { agingIntoMedicareSchema } from "./agingIntoMedicareSchema.ts";
import { lapseSchema } from "./lapseSchema.ts";
import { qrCodeSchema } from "./qrCodeSchema.ts";
import { recurringWorkRequirementSchema } from "./recurringWorkRequirementSchema.ts";
import { redeterminationSchema } from "./redeterminationSchema.ts";
import { selfPayConversionSchema } from "./selfPayConversionSchema.ts";
import { serviceIntroductionSchema } from "./serviceIntroductionSchema.ts";

export const shortCodeContextSchema = z.union([
  z
    .lazy(() => adHocSelfPaySchema)
    .and(
      z.object({
        type: z.literal("VANCE_AD_HOC_SELF_PAY"),
      }),
    ),
  z
    .lazy(() => agingIntoMedicareSchema)
    .and(
      z.object({
        type: z.literal("VANCE_AGING_INTO_MEDICARE"),
      }),
    ),
  z
    .lazy(() => lapseSchema)
    .and(
      z.object({
        type: z.literal("VANCE_LAPSE"),
      }),
    ),
  z
    .lazy(() => qrCodeSchema)
    .and(
      z.object({
        type: z.literal("VANCE_QR_CODE"),
      }),
    ),
  z
    .lazy(() => recurringWorkRequirementSchema)
    .and(
      z.object({
        type: z.literal("VANCE_RECURRING_WORK_REQUIREMENT"),
      }),
    ),
  z
    .lazy(() => redeterminationSchema)
    .and(
      z.object({
        type: z.literal("VANCE_REDETERMINATION"),
      }),
    ),
  z
    .lazy(() => selfPayConversionSchema)
    .and(
      z.object({
        type: z.literal("VANCE_SELF_PAY_CONVERSION"),
      }),
    ),
  z
    .lazy(() => serviceIntroductionSchema)
    .and(
      z.object({
        type: z.literal("VANCE_SERVICE_INTRODUCTION"),
      }),
    ),
]);
